(() => {
  const featuredSwiper = new Swiper(".featured-collection-swiper", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 25,
    navigation: {
      nextEl: ".swiper-button-next-featured-collection",
      prevEl: ".swiper-button-prev-featured-collection",
    },       
    breakpoints: {
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          }
        }
  });
})();
